import {
  CmpButton,
  CmpStatusIcon,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  ErrorMsgDetail,
  GetItemFullSearchArr,
  fItemCodeDependency,
  GetSearchItem,
  xGC_Toggle_Head_BinName_GridColumns,
  xGC_Toggle_Head_BinName_DropDown_Arr,
  GetUnitArr,
  fValidationDetail_Client,
  fValidationHead_Client,
  //item
  GCToggleSearch_ItemName_Columns,
  GCToggleSearch_ItemName_Select_Arr,
  fDisplay,
  //save
  fSaveHead,
  fLoad_Grid,
  fApproveHead,
  GetValidateHead_Server,
  GetValidateDetail_Server,
  BarcodeFlag,
} from "./PutAwayAction";
import {
  fAlertToast,
  fcovertToNumber,
  GetCheck_Monthend_DueDate,
  fcheck_null_undefine_replace_empty,
  GetGitterColumns,
  Get_ToggleDropDown_binsearch_Load,
} from "../../Utility/Utilitys";

import { fExecuteAPI } from "../../Server/Apis";
import {
  Set_SlicePutAway_HeadObj,
  Set_SlicePutAway_HeadObj_New_Set,
} from "./SlicePutAway";
import React, { useState, useEffect, useRef, useCallback } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import InstantPickingBreadcrumbs from "./PutAway_BreadCrumbs";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";
import "./PutAway.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import BinModal from "./processComponent/BinModal";
import GCPutAwayMenuBtn from "./processComponent/PutAwayBtn";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import InputDisplay from "./processComponent/InputDisplay";
import moment from "moment";
import { Stack } from "@mui/material";
import CardComp from "../../Component/Common/ReuseableComponent/Card";

export default function PutAwayDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // const {
  //   GRNDocTyp,
  //   GrnDocNo,
  //   PUTAWAYFromNotification = "N",
  // } = !!location?.state
  //   ? location?.state
  //   : {
  //       GRNDocTyp: "",
  //       GrnDocNo: "",
  //       PUTAWAYFromNotification: "N",
  //     };

  // // get data from another tab
  // const saved = JSON.parse(localStorage.getItem("putawayData")) || {};
  // const {
  //   GRNDocTyp = "",
  //   GrnDocNo = "",
  //   PUTAWAYFromNotification = "N",
  // } = saved;

   // Read from location.state if available
    const stateData = location.state || {};

    // Read from localStorage (new tab case)
    const saved = JSON.parse(localStorage.getItem("putawayData")) || {};

    // Merge both (location.state takes priority)
    const {
      GRNDocTyp = "",
      GrnDocNo = "",
      PUTAWAYFromNotification = "N",
    } = {
      ...saved,
      ...stateData,
    };

  const BarcodeFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const Detail_Grid_columns = [
    {
      field: "P_SrNo",
      headerName: "Sr No",
      width: 50,
    },
    {
      field: "P_CardID",
      headerName: "CardID",
      width: 150,
    },
    {
      field: "P_ItmCd",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 320,
    },
    {
      field: "P_BinCd",
      headerName: "BinCd",
      width: 50,
      hide: true,
    },
    {
      field: "BinName",
      headerName: "BinName",
      width: 300,
    },

    {
      field: "P_Qty",
      headerName: "Qty",
      width: 50,
    },
    {
      field: "P_Unit",
      headerName: "Unit",
      width: 100,
    },
    {
      field: "P_BaseQty",
      headerName: "Base Qty",
      width: 100,
    },
  ];
  const vRdxHead = useSelector((state) => state.SlicePutAway.value.HeadObj);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxDBLocation = useSelector((state) => state.SliceGRNLocation.value);
  const sEnterKeyObj = {
    key: "Enter",
  };
  const vInitHeadError = {
    DocType: "",
    DocName: "",
    DocNo: "",
    Date: "",
    Loc: "",
    LocName: "",
    UnloadingBin: "",
    UnloadingBinName: "",
    Auto: "",
    A_DocStat: "",
  };
  const [sErrorMsg, setErrorMsg] = useState({
    DocType: "",
    DocName: "",
    DocNo: "",
    Date: "",
    Loc: "",
    LocName: "",
    UnloadingBin: "",
    UnloadingBinName: "",
    Auto: "",
    A_DocStat: "",
  });
  const fLocation = async (e) => {
    dispatch(
      Set_SlicePutAway_HeadObj({
        ...vRdxHead,
        Loc: e.target.value,
      })
    );
    setBufferObj((obj) => ({
      ...obj,
      B_BinCode: "",
      B_BinName: "",
    }));
  };

  const fDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      dispatch(
        Set_SlicePutAway_HeadObj({
          ...vRdxHead,
          Date: "",
        })
      );
    } else {
      dispatch(
        Set_SlicePutAway_HeadObj({
          ...vRdxHead,
          Date: event?.$d,
        })
      );
    }
    // dispatch(
    //   Set_SlicePutAway_HeadObj({
    //     ...vRdxHead,
    //     Date: event.$d,
    //   })
    // );
  };

  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);
  const [sDetail_Grid_Row, setDetail_Grid_Row] = useState([]);

  const sRoundingVal = 4;
  const fDetail_Grid_onRowClick = async (item) => {
    await GetCartIDDetail(item.row.P_CardID, item.row.P_SrNo);
    let currentUnitArr = await GetUnitArr(item.row.P_ItmCd, setUnit);
    let vUnitvalue = currentUnitArr.find((obj) => {
      return obj.Unit === item.row.P_Unit;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
    setBufferObj((obj) => ({
      ...obj,
      B_Srno: item.row.P_SrNo,
      B_CardId: item.row.P_CardID,
      B_Itmcd: item.row.P_ItmCd,
      B_Itmcd2: item.row.P_ItmCd,
      B_ItmName: item.row.ItmName,
      B_BinCode: item.row.P_BinCd,
      B_BinName: item.row.BinName,
      B_Qty: item.row.P_Qty,
      B_Barcode: !!item?.row?.P_Barcode ? item?.row?.P_Barcode : "",
      SuppRefNo1: item.row.SuppRefNo1,
      v_P_ExpDt: item.row.ExpDt,
    }));
    setBufferObj((obj) => ({
      ...obj,
      v_P_ExpDt: item.row.ExpDt, // GetCartIDDetail exp is updating by ddefault
    }));
    fCloseViewModal();
  };

  let vBufferObjInit = {
    B_Srno: 0, // int
    B_CardId: "",
    B_Barcode: "",
    B_Itmcd: "",
    B_Itmcd2: "",
    SuppRefNo1: 0,
    B_ItmName: "",
    B_BinCode: "",
    B_BinName: "",
    B_Qty: (0).toFixed(sRoundingVal), //Decimal
    B_Unit: "",
    B_UnitName: "",
    B_PackQty: (0).toFixed(sRoundingVal), //Decimal
    B_Packing: 0, //Decimal
    B_BaseQty: 0, //Decimal
    B_BatchNo: 0,
    B_GrnQty: 0,
    B_PutAwayQty: 0,
    B_BalanceQty: 0,
    v_P_ExpDt: new Date(),
  };

  const [sBufferObj, setBufferObj] = useState(vBufferObjInit);

  const [sUnit, setUnit] = useState([]);
  const fContent_Focus = (e) => {
    if (Number(e.target.value) === 0) {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };

  const fContent_Blur = (e) => {
    if (e.target.value === "") {
      setBufferObj((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };
  const fUnit = async (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: vUnitvalue?.Unit,
      B_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      B_Packing: vUnitvalue?.PackDesc,
    }));
  };

  const fQty = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Qty: e.target.value,
    }));
  };
  const fQty_Enter = (e) => {
    if (e.key === "Enter") {
      fSave();
      document.getElementsByName("B_Qty")[0].blur();
    }
  };
  const fCardId = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_CardId: e.target.value,
    }));
    fCardId_BackSpace_Clear();
  };
  const fExpDate = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setBufferObj((obj) => ({
        ...obj,
        v_P_ExpDt: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        v_P_ExpDt: event?.$d,
      }));
    }
  };
  const fCardId_BackSpace_Clear = () => {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: "",
      B_ItmName: "",
      B_Unit: "",
      B_PackQty: 0,
      B_BaseQty: 0,
      B_Packing: 0,
      B_BatchNo: 0,
      B_GrnQty: 0,
      B_PutAwayQty: 0,
      B_BalanceQty: 0,
      SuppRefNo1: 0,
    }));
    setUnit([]);
  };

  //API NOTIFICATION_PICKINGCARDIDSEARCH_GETROW
  const GetCartIDDetail = async (xCardId, xBSrno = "0") => {
    const CartBarcodeDetailObj = {
      vocTyp: vRdxHead.DocType,
      vocNo: vRdxHead.DocNo,
      srNo: xBSrno,
      cardId: xCardId,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "PUTAWAY_getCardDetail_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd: CartBarcodeDetail.ResultSet[0].ItmCd,
          B_ItmName: CartBarcodeDetail.ResultSet[0].Name2,
          B_BatchNo: CartBarcodeDetail.ResultSet[0].BatchNo,
          B_GrnQty: CartBarcodeDetail.ResultSet[0].GRN,
          B_PutAwayQty: CartBarcodeDetail.ResultSet[0].PutAwayQty,
          B_BalanceQty: CartBarcodeDetail.ResultSet[0].BalanceQty,
          SuppRefNo1: CartBarcodeDetail.ResultSet[0].SuppRefNo1,
          v_P_ExpDt: CartBarcodeDetail.ResultSet[0].ExpDt,
        }));

        let vItemSearchFull = await GetItemFullSearchArr(
          CartBarcodeDetail.ResultSet[0].ItmCd,
          vRdxHead.Loc
        );

        if (vItemSearchFull.length > 0) {
          fItemCodeDependency(
            vItemSearchFull,
            setBufferObj,
            setUnit,
            CartBarcodeDetail.ResultSet[0].Unit
          );
        }
      } else {
        fCardId_BackSpace_Clear();
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else {
      if (!!CartBarcodeDetail?.Message) {
        fAlertToast("FAILED", CartBarcodeDetail?.Message);
      } else {
        fAlertToast("FAILED", CartBarcodeDetail.response.data.message);
      }
    }
  };

  const fCardIdEnter = async (e) => {
    if (e.key === "Enter") {
      if (sBufferObj.B_CardId === "") {
        fAlertToast("FAILED", "CardID is empty");
      } else {
        GetCartIDDetail(sBufferObj.B_CardId);
      }
    } else if (e.key === "Backspace") {
      fCardId_BackSpace_Clear();
    }
  };
  const fBarcode = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_Barcode: e.target.value,
    }));
  };
  const fBarcode_BackSpace_Clear = () => {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd2: "",
    }));
  };

  //API NOTIFICATION_PICKINGCARDIDSEARCH_GETROW
  const GetBarcodeDetail = async (xBarcode) => {
    const CartBarcodeDetailObj = {
      v_Barcode: xBarcode,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "PUTAWAY_putAwayBarcode_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        setBufferObj((obj) => ({
          ...obj,
          B_Itmcd2: CartBarcodeDetail.ResultSet[0].ItmCd,
        }));
      } else {
        fBarcode_BackSpace_Clear();
        fAlertToast("WARNING", "Wrong Barcode");
      }
    } else {
      fAlertToast(
        "FAILED",
        CartBarcodeDetail?.Message ||
          CartBarcodeDetail.response.data.message ||
          "Error"
      );
    }
  };

  const fBarcodeEnter = async (e) => {
    if (e.key === "Enter") {
      if (sBufferObj.B_Barcode === "") {
        fAlertToast("FAILED", "Barcode is empty");
      } else {
        GetBarcodeDetail(sBufferObj.B_Barcode);
      }
    } else if (e.key === "Backspace") {
      fBarcode_BackSpace_Clear();
    }
  };

  //Modal ItemSearch start
  const [
    GCToggleSearch_ItemName_Grid_Row,
    set_GCToggleSearch_ItemName_Grid_Row,
  ] = useState([]);
  //Item Dropdowm
  const [GCToggleSearch_ItemName_Toggle, set_GCToggleSearch_ItemName_Toggle] =
    useState(false);
  const [GCToggleSearch_ItemName_Obj, set_GCToggleSearch_ItemName_Obj] =
    useState({
      Type: "Any",
      Data: "",
    });
  const Toggle_ItemSearch = () => {
    if (GCToggleSearch_ItemName_Toggle) {
      set_GCToggleSearch_ItemName_Toggle(false);
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
      set_GCToggleSearch_ItemName_Obj({
        Type: "Any",
        Data: "",
      });
    } else {
      set_GCToggleSearch_ItemName_Toggle(true);
      // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };

  const GCToggleSearch_ItemName_Sub_Input = (e) => {
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fItemToggleClick = (e) => {
    set_GCToggleSearch_ItemName_Grid_Row([]);
    set_GCToggleSearch_ItemName_Obj((obj) => ({
      ...obj,
      Data: sBufferObj.B_ItmName,
    }));

    if (sBufferObj.B_ItmName != "") {
      GetSearchItem(
        sBufferObj.B_ItmName,
        "Any",
        vRdxHead.Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }

    Toggle_ItemSearch();
  };

  //ItemSearch
  const GCToggleSearch_ItemName_Main_Enter = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.B_ItmName,
        vRdxHead.Loc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_Itmcd: "",
        B_ItmName: e.target.value,
        B_Barcode: "",
        B_Unit: "",
        B_UnitName: "",
        B_PackQty: "",
        SuppRefNo1: 0,
      }));
      setUnit([]);
    }
  };

  //Item search Start
  const GCToggleSearch_ItemName_Main_Input = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_ItmName: e.target.value,
    }));
  };

  const GCToggleSearch_ItemName_RowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(e.row.ItmCd, vRdxHead.Loc);
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      document.getElementsByName("B_ItmName")[0]?.focus();
    }
    set_GCToggleSearch_ItemName_Toggle(false);
  };
  //GCItemSearch
  const GCToggleSearch_ItemName_CellClick = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      GCToggleSearch_ItemName_RowClick(newSelectionModel);
    }
  };
  const GCToggleSearch_ItemName_Sub_Enter = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        GCToggleSearch_ItemName_Obj.Data,
        GCToggleSearch_ItemName_Obj.Type,
        vRdxHead.Loc,
        set_GCToggleSearch_ItemName_Grid_Row
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  //Item search end

  //Bin start

  const xfGC_Toggle_Head_BinName_Name = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_BinName: e.target.value,
      B_BinCode: "",
    }));
  };

  const [
    sGC_Toggle_Head_BinName_SearchDropdownObj,
    setGC_Toggle_Head_BinName_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  const [sGC_Toggle_Head_BinName_GridData, setGC_Toggle_Head_BinName_GridData] =
    useState([]);
  const [
    sGC_Toggle_Head_BinName_ToggleDropDowm,
    setGC_Toggle_Head_BinName_ToggleDropDowm,
  ] = useState(false);

  const xfGC_Toggle_Head_BinName_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_BinName_ToggleDropDowm) {
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Toggle(false);
      setGC_Toggle_Head_BinName_GridData([]);
      setGC_Toggle_Head_BinName_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_BinName_ToggleDropDowm(true);
      set_GCToggleSearch_ItemName_Toggle(false);
    }
  }, [sGC_Toggle_Head_BinName_ToggleDropDowm]);

  //2nd call
  const fGC_Toggle_Head_BinName_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_BinName_SearchDropdownObj((obj) => ({
        ...obj,
        Data: sBufferObj.B_BinName,
      }));
      if (sBufferObj.B_BinName !== "") {
        const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
          sBufferObj.B_BinName,
          "Any",
          "N",
          vRdxHead.Loc
        );

        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_BinName_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_BinName_GridData([]);
        }
      }
      xfGC_Toggle_Head_BinName_Toggle();
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  };
  //binmodal start

  const [sBinModal, setBinModal] = useState(false);
  const [sBin_Grid_Row_Modal, set_Grid_Row_Modal] = useState([]);
  const [Grid_Columns, set_Grid_Columns] = useState([
    {
      field: "Aisle",
      headerName: "Aisle",
      width: 90,
    },
    {
      field: "Name1",
      headerName: "Bin Name",
      width: 150,
    },
    {
      field: "BalanceQty",
      headerName: "BalanceQty",
      width: 90,
      hide: true,
    },
  ]);
  const fputAwayBin = async () => {
    let obj = {
      v_VocTyp: vRdxHead.DocType,
      v_VocNo: vRdxHead.DocNo,
      v_ItmCd: sBufferObj.B_Itmcd,
    };
    if (sBufferObj.B_Itmcd == "") {
      fAlertToast("FAILED", "Item code should not be  empty");
      return;
    } else {
      const vPutaway = await fExecuteAPI("PUTAWAY_putAwayBiny_GETROW", obj);
      if (vPutaway?.Type?.toUpperCase() === "SUCCESS") {
        setBinModal(true);
        console.log("khkhkjkhkhjk", vPutaway?.ResultSet);
        if (vPutaway?.ResultSet?.length > 0) {
          const itemRows = vPutaway?.ResultSet?.map((obj, i) => ({
            ...obj,
            id: i + 1,
            // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
          }));
          set_Grid_Row_Modal(itemRows);
        } else {
          set_Grid_Row_Modal([]);
        }
      } else {
        fAlertToast("FAILED", vPutaway?.Message);
      }
    }
  };
  //binmodal end

  //1stcall
  const fGC_Toggle_Head_BinName_onKeyUp = async (e) => {
    // fBinNameKey(e);
    if (e.key === "Enter" || e._reactName === "onClick") {
      if (sBufferObj.B_BinName == "") {
        // fAlertToast("FAILED", "BinName is empty");
        fputAwayBin();
        // return;
      } else {
        const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
          sBufferObj.B_BinName,
          "Any",
          "Y",
          vRdxHead.Loc
        );

        if (vExactSearch.length > 0) {
          setBufferObj((obj) => ({
            ...obj,
            B_BinCode: vExactSearch[0].UId,
            B_BinName: vExactSearch[0].Name1,
          }));

          setTimeout(() => {
            const element = document.querySelector('[tabindex="104"]');
            element?.focus();
          }, 100);
        } else {
          //fAlertToast("FAILED", "Wrong Bin Name");
          fGC_Toggle_Head_BinName_Dropdown_SearchModalKey(e);
        }
        if (sBufferObj.B_BinCode !== "") {
          setTimeout(() => {
            const element = document.querySelector('[tabindex="104"]');
            element?.focus();
          }, 100);
        }
      }
    }
    if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_BinCode: "",
      }));
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_BinName_Dropdown_onChange = (e) => {
    setGC_Toggle_Head_BinName_SearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_binsearch_Load(
        sGC_Toggle_Head_BinName_SearchDropdownObj.Data,
        sGC_Toggle_Head_BinName_SearchDropdownObj.Type,
        "N",
        vRdxHead.Loc
      );

      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_BinName_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_BinName_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_BinName_OnRowClick = async (e) => {
    setBufferObj((obj) => ({
      ...obj,
      B_BinCode: e?.row?.UId,
      B_BinName: e?.row?.Name1,
    }));
    setTimeout(() => {
      const element = document.querySelector('[tabindex="104"]');
      element?.focus();
    }, 100);
    xfGC_Toggle_Head_BinName_Toggle();
  };

  const fGC_Toggle_Head_BinName_OnCellKeyDown = (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGC_Toggle_Head_BinName_OnRowClick(newSelectionModel);
    }
  };

  //Bin end
  let timeout = null;
  const fSave = async (e) => {
    clearTimeout(timeout);
    fClearErrorMsg();
    timeout = setTimeout(async () => {
      if (vRdxHead?.A_DocStat !== "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxHead?.A_DocStat + " mode"
        );
        return;
      }

      let validation = fValidationHead_Client(
        vRdxHead,
        setErrorMsg,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      let validationDetil = fValidationDetail_Client(
        sBufferObj,
        setErrorMsgDetail
      );

      if (!validationDetil) return;

      let iValidateDetail = await GetValidateDetail_Server(
        dispatch,
        sBufferObj
      );

      if (!iValidateDetail) return;

      if (BarcodeFlag() && sBufferObj.B_Itmcd != sBufferObj.B_Itmcd2) {
        fAlertToast(
          "FAILED",
          " Item codes for Card ID and Barcode are mismatched"
        );
        return;
      }

      fSaveHead(fNewDetail, sBufferObj, dispatch, navigate);
    }, 500);
  };

  const fApprove = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (sBufferObj.B_Itmcd !== "") {
        fAlertToast("FAILED", "Please save current line item before approve");
        return;
      }

      if (sDetail_Grid_Row.length === 0) {
        fAlertToast("INFO", "Add atleast one line item");
        return;
      }
      let validation = fValidationHead_Client(
        vRdxHead,
        setErrorMsg,
        vMediaQuery,
        fSummary
      );

      if (!validation) return;

      let CheckDueDate = await GetCheck_Monthend_DueDate(
        vRdxHead.Loc,
        vRdxHead.Date
      );
      if (!CheckDueDate) return;

      fApproveHead(fNewDetail, dispatch);

      //by sir for lutfi and also for other client
      // let iRecSet = await GetValidateHead_Server();
      // if (iRecSet.length > 0 && iRecSet[0]["count"] > 0  ) {
      //   confirmAlert({
      //     title: "User did not complete posting",
      //     message: "Are you sure to approve?",
      //     buttons: [
      //       {
      //         className: "alertBtn",
      //         label: "Yes",
      //         onClick: () => {
      //           fApproveHead(fNewDetail, dispatch);
      //         },
      //       },
      //       {
      //         className: "alertBtn",
      //         label: "No",
      //         onClick: () => {},
      //       },
      //     ],
      //   });
      // } else {
      //   fApproveHead(fNewDetail, dispatch);
      // }
    }, 500);
  };

  const fClearErrorMsg = () => {
    setErrorMsg(vInitHeadError);
    setErrorMsgDetail(ErrorMsgDetail);
  };

  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.B_ItmName === "") {
      fNewHead();
      fNewDetail();
      document?.getElementsByName("Date")[0]?.focus();
    } else {
      fNewDetail();
    }
  };
  //Modal View
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //Modal View
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  const fNewHead = async () => {
    dispatch(
      Set_SlicePutAway_HeadObj_New_Set({
        Date: new Date(),
      })
    );
    setDetail_Grid_Row([]);
    setBufferObj(vBufferObjInit);
    document.getElementsByName("Date")[0]?.focus();
  };

  //vTaxType  vTaxType ==  sTax[1].Uid then tax %0
  const fNewDetail = () => {
    setBufferObj(vBufferObjInit);

    setUnit([]);

    fLoad_Grid(setDetail_Grid_Row);

    document.getElementsByName("B_CardId")[0]?.focus();
  };

  const fDelete = (e) => {
    if (vRdxHead.A_DocStat === "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (sBufferObj.B_Srno == 0) {
      fAlertToast("FAILED", "Select atleast one lineitem");
      return;
    } else {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete line item.",
        buttons: [
          {
            className: "alertBtn",
            label: "Yes",
            onClick: () => {
              fDeleteDetail();
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
    }
  };

  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async () => {
    let vDeleteSIDetailObj = {
      vocTyp: vRdxHead.DocType,
      vocNo: vRdxHead.DocNo,
      srNo: sBufferObj.B_Srno,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await fExecuteAPI(
      "PUTAWAY_deteteItem_GETROW",
      FinalObj
    );

    if (vDeleteSIDetail?.Type?.toUpperCase() === "SUCCESS") {
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
      fNewDetail();
    } else if (vDeleteSIDetail?.Type?.toUpperCase() === "FAILED") {
      fAlertToast("FAILED", vDeleteSIDetail?.Status);
    } else {
      fAlertToast("FAILED", vDeleteSIDetail?.response?.data?.Status);
    }
  };
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };
  const fPrint = useCallback(
    (xPrnTyp) => {
      // http://94.200.177.214:3010/WMS/PutAway?prntyp=PUAWAY_GRN&voctyp=WG01&vocno=WIB0000001&reporttile=GRN%20Vs%20Putaway
      let urlPrint =
        vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val +
        "WMS/PutAway?prntyp=" +
        xPrnTyp +
        "&voctyp=" +
        vRdxHead?.DocType +
        "&vocno=" +
        vRdxHead?.DocNo +
        "&reporttile=GRN Vs Putaway";
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxHead?.DocType, vRdxHead?.DocNo, vRdxDBKernObj]
  );

  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      set_GCToggleSearch_ItemName_Toggle(false);
      setGC_Toggle_Head_BinName_ToggleDropDowm(false);
      set_GCToggleSearch_ItemName_Grid_Row([]);
      setGC_Toggle_Head_BinName_GridData([]);
    }
  }, []);
  // useEffect(() => {
  //   const handleClick = (event) => {
  //     if (sGC_Toggle_Head_BinName_ToggleDropDowm) {
  //       const toggleElement = event.target.closest(".toggleSearch");

  //       if (!toggleElement) {
  //         setGC_Toggle_Head_BinName_ToggleDropDowm(false);
  //       }
  //     }
  //   };
  //   document.addEventListener("click", handleClick);
  //   return () => {
  //     document.removeEventListener("click", handleClick);
  //   };
  // }, [sGC_Toggle_Head_BinName_ToggleDropDowm]);
  useEffect(() => {
    setBufferObj((obj) => ({
      ...obj,
      B_BaseQty: fcovertToNumber(sBufferObj.B_Qty * sBufferObj.B_PackQty),
    }));
  }, [sBufferObj.B_Qty, sBufferObj.B_PackQty]);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);
  useEffect(() => {
    fLoad_Grid(setDetail_Grid_Row);
  }, []);
  useEffect(() => {
    BarcodeFocusOnLoad?.current?.focus();
  }, []);

  useEffect(() => {
   

    if (GRNDocTyp !== "" && GrnDocNo !== "") {
      setTimeout(() => {
        fDisplay(GRNDocTyp, GrnDocNo, dispatch, fNewDetail);

        location.state = {
          GRNDocTyp: "",
          GrnDocNo: "",
          PUTAWAYFromNotification: PUTAWAYFromNotification,
        };

        // get data from another tab
        // Clear data after using it
         localStorage.removeItem("putawayData");
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //variance start
  const [sOpenPostVarianceModel, setOpenVarianceModel] = useState(false);

  const [sGridVarienceRow, setGridVarienceRow] = useState([]);

  const [sVarianceColumns, setVarianceColumns] = useState([
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 90,
      hide: true,
    },
    {
      field: "Name1",
      headerName: "Item Name",
      width: 250,
    },
    {
      field: "CardID",
      headerName: "CardID",
      width: 110,
    },

    {
      field: "GRNQty",
      headerName: "GRNQty",
      width: 50,
    },
    {
      field: "PUTAWAYQty",
      headerName: "PUTAWAYQty",
      width: 50,
    },
  ]);
  const fCloseVarianceModel = () => {
    setOpenVarianceModel(false);
  };

  const fOpenVarianceModel = () => {
    setOpenVarianceModel(true);
  };
  //API DISPATCH_VARIANCE_ITEMS_GETROW
  const GetVariance = async () => {
    let vVarianceObj = {
      vocTyp: vRdxHead.DocType,
      vocNo: vRdxHead.DocNo,
    };
    const vVariance = await fExecuteAPI(
      "PUTAWAY_putAwayVariance_GETROW",
      vVarianceObj
    );
    if (vVariance.Type == "SUCCESS") {
      fOpenVarianceModel();
      if (vVariance.ResultSet.length > 0) {
        let GridID = vVariance.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setGridVarienceRow(GridID);
      }
    } else {
      fAlertToast(
        "FAILED",
        vVariance.Message ||
          vVariance.response.data.Status ||
          "Error in Varience"
      );
    }
  };
  //variance end

  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([]);

  useEffect(() => {
    GetGitterColumns(
      setSummaryGridColumn2,
      "WMINV03BIN_DETAIL",
      Detail_Grid_columns
    );
    GetGitterColumns(setVarianceColumns, "PutAway_VARIANCE", sVarianceColumns);
    GetGitterColumns(set_Grid_Columns, "PutAway_Bin", Grid_Columns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="Breadcrumbs">
        <InstantPickingBreadcrumbs />
      </div>
      <Grid container spacing={2} className="container-fluid">
        <Grid item xs={12} md={8}>
          {vMediaQuery ? (
            " "
          ) : (
            <WmsHead
              xref={BarcodeFocusOnLoad}
              vRdxHead={vRdxHead}
              xErrorMsg={sErrorMsg}
              vRdxuserLoc={vRdxDBLocation}
              fLocation={fLocation}
              fDate={fDate}
            />
          )}
          <WmsContent
            fExpDate={fExpDate}
            sEnterKeyObj={sEnterKeyObj}
            vMediaQuery={vMediaQuery}
            xContent_Focus={fContent_Focus}
            xContent_Blur={fContent_Blur}
            xErrorMsgDetail={sErrorMsgDetail}
            xBufferObj={sBufferObj}
            sUnit={sUnit}
            fUnit={fUnit}
            fQty={fQty}
            fQty_Enter={fQty_Enter}
            fCardId={fCardId}
            fCardIdEnter={fCardIdEnter}
            fBarcode={fBarcode}
            fBarcodeEnter={fBarcodeEnter}
            //GC toggle
            fItemName={GCToggleSearch_ItemName_Main_Input} //onchange main input
            xMediaQuery={vMediaQuery} //mobile screen
            xonClickbtn={GCToggleSearch_ItemName_Main_Enter} // onclick icon open div on main screen
            xrows={GCToggleSearch_ItemName_Grid_Row} //Grid Row GCToggle Search from API
            xcolumns={GCToggleSearch_ItemName_Columns} //GCToggleSearch-Grid col GCToggle Search fron Action
            xRowCellClick={GCToggleSearch_ItemName_CellClick} //GCToggleSearch-grid clic
            xRowClick={GCToggleSearch_ItemName_RowClick} //GCToggleSearch- grid click
            xToggle={GCToggleSearch_ItemName_Toggle} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
            xData={GCToggleSearch_ItemName_Select_Arr} // GCToggleSearch-select-tag arr
            xOnChangeDropdownInput={GCToggleSearch_ItemName_Sub_Input} //GCToggleSearch-input search onchane DATA/TYPE
            xDropdownObj={GCToggleSearch_ItemName_Obj} // GCToggleSearch-object DATA/TYPE
            xOnKeyUpDropdownInput={GCToggleSearch_ItemName_Sub_Enter} //GCToggleSearch-
            //customer

            xGC_Toggle_Head_BinName_DropDown_Arr={
              xGC_Toggle_Head_BinName_DropDown_Arr
            } //sub input arr
            xfGC_Toggle_Head_BinName_Name={xfGC_Toggle_Head_BinName_Name} //onchange main input
            xGC_Toggle_Head_BinName_Toggle={
              sGC_Toggle_Head_BinName_ToggleDropDowm
            } //boolean true  false
            xGC_Toggle_Head_BinName_onKeyUp={fGC_Toggle_Head_BinName_onKeyUp} //main input enter
            xGC_Toggle_Head_BinName_SearchDropdownObj={
              sGC_Toggle_Head_BinName_SearchDropdownObj
            } //sub input obj
            xGC_Toggle_Head_BinName_Dropdown_onChange={
              fGC_Toggle_Head_BinName_Dropdown_onChange
            } //sub input onchange
            xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load={
              fGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load
            } //sub input load
            xGC_Toggle_Head_BinName_GridColumns={
              xGC_Toggle_Head_BinName_GridColumns
            } //sub input col
            xGC_Toggle_Head_BinName_GridData={sGC_Toggle_Head_BinName_GridData} //sub input grid
            xfGC_Toggle_Head_BinName_OnCellKeyDown={
              fGC_Toggle_Head_BinName_OnCellKeyDown
            } //sub input row enter
            xfGC_Toggle_Head_BinName_OnRowClick={
              fGC_Toggle_Head_BinName_OnRowClick
            } //sub input row click
          />
          {/* action buttons */}
          <Stack
            direction={"row"}
            justifyContent={"center"}
            flexWrap={"wrap"}
            gap={2}
            mt={2}
          >
            <CmpButton
              xbtnName="New"
              xOnClick={fNew}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xId={"IdNew"}
              xSendIcon={<AddBoxRoundedIcon />}
            />
            <CmpButton
              xbtnName="Save"
              xOnClick={fSave}
              xVariant="contained"
              xDisabled={vRdxHead.A_DocStat !== "ENTER"}
              xSize="small"
              xId={"IdSave"}
              xSendIcon={<SaveRoundedIcon />}
            />
            <CmpButton
              xbtnName="Delete"
              xOnClick={fDelete}
              xVariant="contained"
              xDisabled={vRdxHead.A_DocStat !== "ENTER"}
              xSize="small"
              xId="IdDelete"
              xSendIcon={<DeleteRoundedIcon />}
            />
            {PUTAWAYFromNotification !== "Y" && (
              <CmpButton
                xbtnName="Approve"
                xOnClick={fApprove}
                xVariant="contained"
                xDisabled={
                  vRdxHead.A_DocStat !== "ENTER" ||
                  PUTAWAYFromNotification == "Y"
                }
                xSize="small"
                xId={"IdApprove"}
                xSendIcon={<CheckCircleOutlineRoundedIcon />}
              />
            )}
            {vMediaQuery && (
              <CmpButton
                xbtnName="Detail"
                xOnClick={fView}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xSendIcon={<RemoveRedEyeIcon />}
              />
            )}

            {/* <GCPutAwayMenuBtn
              menuLabel="More"
              menuItems={[
                { label: "Detail", onClick: fView },
                { label: "Variance", onClick: GetVariance },
                // { label: "Link Document", onClick: fLinkDocument },
              ]}
              xvariant="contained"
            /> */}

            {/* <CmpButton
              xbtnName="Summary"
              xOnClick={fSummary}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xSendIcon={<RemoveRedEyeIcon />}
            /> */}

            <CmpButton
              xbtnName="Variance"
              xOnClick={GetVariance}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              // xSendIcon={<CheckCircleOutlineRoundedIcon />}
            />
            {/* </Grid> */}
            <DropdownButton
              id="dropdown-basic-button"
              title="Print"
              variant="primary"
              size="xs"
            >
              <Dropdown.Item
                id="IdPrint"
                onClick={(e) => {
                  fPrint("PUAWAY_GRN");
                }}
              >
                PUAWAY_GRN
              </Dropdown.Item>
              <Dropdown.Item
                onClick={(e) => {
                  fPrint("PUAWAY_DTL");
                }}
              >
                PUAWAY_DTL
              </Dropdown.Item>
            </DropdownButton>
          </Stack>
        </Grid>
        <Grid item xs={12} md={4}>
          <div
            className="xs-screen-hide"
            style={{ height: "78vh", overflowY: "auto" }}
          >
            <Grid container spacing={1}>
              {Array.isArray(sDetail_Grid_Row) &&
              sDetail_Grid_Row?.length > 0 ? (
                sDetail_Grid_Row?.map((data, index) => (
                  <Grid item xs={12} sm={6} md={12} key={index}>
                    <CardComp
                      data={data}
                      maxHeight="165px"
                      onClick={(item) => {
                        fDetail_Grid_onRowClick({ row: item });
                      }}
                      content={
                        <Grid container columnSpacing={{ xs: 2 }}>
                          <InputDisplay label="Sr No" value={data?.P_SrNo} />
                          <InputDisplay
                            label="Card ID"
                            value={data?.P_CardID}
                          />
                          <InputDisplay
                            label="Bin Name"
                            value={data?.BinName}
                          />
                          <InputDisplay label="Qty" value={data?.P_Qty} />
                          <InputDisplay label="Unit" value={data?.P_Unit} />
                          <InputDisplay
                            label="Base Qty"
                            value={data?.P_BaseQty}
                          />
                          <InputDisplay
                            label="Expected Date"
                            value={moment(data?.ExpDt)?.format("DD/MM/YYYY")}
                          />
                          <InputDisplay
                            label="Item Name"
                            value={data?.ItmName}
                          />
                        </Grid>
                      }
                    />
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <div
                    style={{
                      width: "auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <p>No Data Found</p>
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
      </Grid>
      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance detail">
          <GCTitleSticky title={"Detail"} onClose={fCloseViewModal} />
          <div className="py-2">
            <Grid container spacing={1}>
              {Array.isArray(sDetail_Grid_Row) &&
                sDetail_Grid_Row?.length > 0 &&
                sDetail_Grid_Row?.map((data, index) => (
                  <Grid item xs={12} key={index}>
                    <CardComp
                      data={data}
                      maxHeight="165px"
                      onClick={(item) => {
                        fDetail_Grid_onRowClick({ row: item });
                      }}
                      content={
                        <Grid container columnSpacing={{ xs: 2 }}>
                          <InputDisplay label="Sr No" value={data?.P_SrNo} />
                          <InputDisplay
                            label="Card ID"
                            value={data?.P_CardID}
                          />
                          <InputDisplay
                            label="Bin Name"
                            value={data?.BinName}
                          />
                          <InputDisplay label="Qty" value={data?.P_Qty} />
                          <InputDisplay label="Unit" value={data?.P_Unit} />
                          <InputDisplay
                            label="Base Qty"
                            value={data?.P_BaseQty}
                          />
                          <InputDisplay
                            label="Expected Date"
                            value={moment(data?.ExpDt)?.format("DD/MM/YYYY")}
                          />
                          <InputDisplay
                            label="Item Name"
                            value={data?.ItmName}
                          />
                        </Grid>
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </div>
        </Box>
      </Modal>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary"} onClose={fCloseSummaryModal} />

          <WmsHead
            xref={BarcodeFocusOnLoad}
            vRdxHead={vRdxHead}
            xErrorMsg={sErrorMsg}
            vRdxuserLoc={vRdxDBLocation}
            fLocation={fLocation}
            fDate={fDate}
          />
        </Box>
      </Modal>

      {/* variance  */}
      <Modal
        open={sOpenPostVarianceModel}
        onClose={fCloseVarianceModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="model-Variance"
          sx={{
            height: { xs: "100vh", md: "90vh" },
            width: { xs: "100%", md: "95%" },
          }}
        >
          <GCTitleSticky title={"Variance"} onClose={fCloseVarianceModel} />
          <Grid container spacing={1} sx={{ p: 2 }}>
            {Array.isArray(sGridVarienceRow) && sGridVarienceRow?.length > 0 ? (
              sGridVarienceRow?.map((data, index) => (
                <Grid item xs={12} sm={6} lg={4} key={index}>
                  <CardComp
                    data={data}
                    // onClick={(item) => {
                    //   fDetail_Grid_onRowClick({ row: item });
                    // }}
                    maxHeight={"120px !important"}
                    content={
                      <Grid container columnSpacing={{ xs: 2 }}>
                        <InputDisplay label="Item Code" value={data?.ItmCd} />
                        <InputDisplay label="Item Name" value={data?.Name1} />
                        <InputDisplay label="Card ID" value={data?.CardID} />
                        <InputDisplay label="GRN Qty" value={data?.GRNQty} />
                        <InputDisplay
                          label="PUT AWAY Qty"
                          value={data?.PUTAWAYQty}
                        />
                        <InputDisplay label="Variance" value={data?.Variance} />
                      </Grid>
                    }
                  />
                </Grid>
              ))
            ) : (
              <p>No Data Found</p>
            )}
          </Grid>
          =
        </Box>
      </Modal>

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />

      {/* binmodal  */}
      <BinModal
        sBinModal={sBinModal}
        setBinModal={() => {
          setBinModal(false);
        }}
        xMediaQuery={vMediaQuery}
        Grid_Columns={Grid_Columns}
        Grid_Row={sBin_Grid_Row_Modal}
        sModalRowClick={(item) => {}}
      />
    </>
  );
}
